<template>
  <v-container fluid align-start ma-0 pa-2 class="sys0020-main container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[                      
                      'btnCreate',                
                    ]"                    
                    @btnAdd="createUsers()"                    
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Authority Group : '"/>
                          <v-col cols="2">
                            <v-select
                              v-model="authDiv.select"
                              :items="authDiv.items"
                              item-text="name"                              
															item-value="cd"
                              return-object 
                              single-line
                              dense 
                              outlined 
                              hide-details="auto"                              
                             ></v-select>
                          </v-col>
                          <i-label class="pl-2 pb-0" :label="'User:'"/>
                          <v-col cols="1">
                            <v-text-field
                             v-model="NewID"
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable                           
                             ></v-text-field>                                                                                                                            
                          </v-col>
                        <v-col cols="1">
                          <v-btn class="mx-sm-2" small color="yellow" @click="addUsers()"> Search New User </v-btn>           
                        </v-col>  
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="6" class="pa-1">                                               
                <i-card-vertical
                    headerTitle="User List" 
                    :useBtnList="[
                      'btnSearch'
                    ]"
                   @btnSearch="searchUsers()"    
                ></i-card-vertical>    
                
                <v-row no-gutters>
                  <v-col cols="12" class="pt-1">
                      <DxDataGrid
                        id="users"
                        class="hipGridHeight1"
                        :ref="usersRef"
                        :data-source="usersList"
                        :remote-operations="false"
                        :hover-state-enabled="true"
                        :allow-column-resizing="true"
                        :allow-column-reordering="true"
                        :row-alternation-enabled="true"
                        :show-borders="true"
                        :width="grid.width"
                        :show-row-lines="true"
                        key-expr="userId"
                        :focused-row-enabled="true"
                        @focusedRowChanged="usersRowClick"
                        :column-hiding-enabled="false"
                        @editing-start="usersEditingStart"
                      >
                        <DxScrolling column-rendering-mode="virtual"/>
                        <DxColumn data-field="userId" :caption="$t('User ID')" width="auto" data-type="string" alignment="center" />
                        <DxColumn data-field="userNm" :caption="$t('User Name')" width="auto" data-type="string" alignment="left" />
                        <DxPaging :enabled="false"/>
                        <!-- <DxSelection
                          select-all-mode="allPages"
                          show-check-boxes-mode="always"
                          mode="multiple" 
                        /> -->
                      </DxDataGrid>   
                      </v-col>
                      </v-row>
                </v-col>

                <v-col cols="6" class="pa-1">
                  <i-card-vertical
                    headerTitle="Menu List" 
                    :useBtnList="[
                      'btnAdd',
                      'btnSave',
                      'btnDelete'
                    ]"
                    @btnAdd="addMenus()"
                    @btnSave="saveMenus()"
                    @btnDelete="deleteMenus()"
                  >
                    <template v-slot:body>
                      <DxTreeList
                        id="menus"
                        class="hipGridHeight1"
                        :ref="menusRef"
                        :data-source="menusList"
                        :hover-state-enabled="true"
                        :allow-column-resizing="true"
                        :allow-column-reordering="true"
                        :row-alternation-enabled="true"
                        :show-borders="true"
                        :width="grid.width"
                        :show-row-lines="true"
                        key-expr="menuId"
                        parent-id-expr="prtMenuId"
                        :focused-row-enabled="true"
                        :column-hiding-enabled="false"
                        :autoExpandAll="true"
                        :selection="{ mode:'multiple' , recursive:true }"
                        :selected-row-keys="rowKey"
                        :expanded-row-keys="expandedRowKeys"
                      >
                        <DxScrolling column-rendering-mode="virtual"/>
                        <DxColumn data-field="menuId" :caption="$t('Menu Code')" :width="150" data-type="string" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="menuNm" :caption="$t('Menu Name')" width="auto" data-type="string" alignment="left" :allow-editing="false"  sort-order="asc"/>
                        <DxPaging :enabled="true" :page-size="10"/>
                      </DxTreeList>
                    </template>
                  </i-card-vertical>
                </v-col>

              </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>

    <sys0020MenuPop :showMenuPop.sync="showMenuPop" :userId="selectedUser ? selectedUser.userId : ''" @selected="getSelectedMenus" />
    <sys0020UserPop :showUserPop.sync="showUserPop" :authCd="authDiv ? authDiv.select.cd  : ''" @selected="getSelectedUsers" />
  </v-container>
</template>

<script>
import { DxDataGrid, DxColumn  } from 'devextreme-vue/data-grid'
import { DxTreeList } from 'devextreme-vue/tree-list'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import notify from 'devextreme/ui/notify'
import sys0020MenuPop from '@/views/hip/Z/popup/sys0020MenuPop'
import sys0020UserPop from '@/views/hip/Z/popup/sys0020UserPop'

// import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getAuths, saveAuths, deleteAuths, getMenus, saveMenus, deleteMenus, getUsers, saveUsers, createUsers } from '@/api/system/authManage'
import { current } from 'devextreme/ui/themes'


export default {
  name: 'sys0020',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxTreeList,
    sys0020MenuPop,
    sys0020UserPop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      authNm: '',
      authsList: [],
      menusList: [],
      rowKey: [],
      expandedRowKeys: [],
      usersList: [],
      // authsRef : 'authsRef',
      usersRef : 'usersRef',
      menusRef : 'menusRef',
      selectedAuth: null,
      selectedUser: null,
      showMenuPop: false,
      showUserPop: false,
      userPopData: [],
      menuPopData: [],
      NewID: '',      
      authCd: '',
      authDiv: {
        select: { name: 'Admin', cd: 'A' },
        items: [
          { name: 'Admin', cd: 'A' }
        ]
      }

    }
  },
  computed: {
  //   authsInstance() {
  //     return this.GetDataGrid(this.authsRef)
  //   },
    menusInstance() {
      return this.GetDataGrid(this.menusRef)
    },
    usersInstance() {
      return this.GetDataGrid(this.usersRef)
    }
  },
  methods: {

    // authsEditingStart(e){
    //   if (e.column.dataField === 'authCd') {
    //     if (e.data.__created__ === false) {
    //       e.cancel = true
    //     }
    //   }
    // },

   
    authCellPrepared(e) {
      if(e.rowType === 'data') {
        if(e.rowType === 'data' && e.rowIndex >= 0) {
          // console.log('e', e)
          if(!e.data.__created__) {
            if(e.column.dataField === 'authCd') {
              e.cellElement.classList.add('cancel-editable-cell')
            }
          }
        }
      }
    },
    menusEditingStart(e) {
      e.cancel = true
    },
    usersEditingStart(e) {
      e.cancel = true
    },
    
    usersRowClick(e) {
      if (e.rowIndex >= 0) {
        if (e.row.data) {
          this.selectedUser = e.row.data
        } else {
          this.selectedUser = null
        }        
        this.searchMenus()
      }
    },

    searchAuths() {
      this.openLoading('searching')

      const param = {
        sysCd: this.$store.state.system.sysCd,
        authNm: this.authNm ? this.authNm : ''
      }

    getAuths(param).then(res => {

         res.list.forEach(e => {              
              this.authDiv.items.push({ name: e.authNm, cd: e.authCd })            
          })

      }).finally(() => {
        this.endLoading()
      })
    },


    searchUsers() {

      this.usersList = []
      this.usersInstance.clearSelection()
      this.selectedUser = null

      // if(this.selectedAuth) {
        this.openLoading('searching')

        if (this.NewID === null) {
          this.NewID = ' '
        }

        const param = {
          sysCd:'HIP',          
          authCd: this.authDiv.select.cd,
          userId: this.NewID
        }
        
      

      getUsers(param).then(res => {
          // console.log('res', res.list)
          this.usersList = res.list

          if(this.usersList.length > 0) {
          this.selectedUser = res.list[0]
          this.usersInstance.option('focusedRowKey', this.selectedUser.Id)
        }

        this.searchMenus()

        }).finally(() => {
          this.endLoading()
        })
      // }
    },

    searchMenus() {

      this.menusList = []
      this.rowKey = []
      this.expandedRowKeys = []
      this.menusInstance.clearSelection()

      // if(this.selectedAuth) {
        this.openLoading('searching')

        // const param = {
        //   sysCd: this.selectedAuth.sysCd,
        //   authCd: this.selectedAuth.authCd
        // }
        
        const param = {
          sysCd: 'HIP',
          authCd: this.authDiv.select.cd,
          userId: this.selectedUser.userId
        }  


        getMenus(param).then(res => {
          // console.log('res', res.list)

          this.menusList = res.list
        }).finally(() => {
          this.endLoading()
        })
      // }
    },

    createUsers(){

      if (this.NewID === null){
          this.vToastify(this.$t('Empty Maker Code') + '[Pls check]', 'warn')
          return
        }

      const params = { authCd: this.authDiv.select.cd,
                       userId: this.NewID, 
                       sysId: 'HIP'
        }

       
        createUsers(params).then(res => {
              // console.log('res', res)

              notify('Create New Authority Success', 'success', 3000)
            })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {              
              this.endLoading()
            })


    },

    getSelectedMenus(e) {
      console.log('e', e)

      for(let i = 0; i < e.length; i++){
        console.log('e'+i, e[i])

        if(!this.$_.some(this.menusList, { menuId: e[i].menuId })) {
          // console.log('e'+i, e[i])
          this.menusList.push({
            sysCd: e[i].sysCd,
            authCd: e[i].authCd,
            menuId: e[i].menuId,
            prtMenuId: e[i].prtMenuId,
            menuNm: e[i].ename,
            __modified__: false,
          __created__: true
          })

          this.rowKey.push(e[i].menuId)

          if(!e[i].prtMenuId) {
            this.expandedRowKeys.push(e[i].menuId)
          }
        }
      }

      // console.log('this.menusList', this.menusList)
    },
    getSelectedUsers(e) {
      // console.log('e', e)

      if ( e.length > 0 ) {
        this.NewID =  e[0].userId;
      }

      // for(let i = 0; i < e.length; i++){
      //   if(!this.$_.some(this.usersList, { userId: e[i].userId })) {
      //     const newRow = {
      //       sysCd: this.selectedAuth.sysCd,
      //       authCd: this.selectedAuth.authCd,
      //       userId: e[i].userId,
      //       userNm: e[i].userNm,
      //       makerCd: e[i].makerCd,
      //       __modified__: false,
      //     __created__: true
      //     }

      //     this.usersInstance.newRow(newRow)
      //     this.usersInstance.selectRows(newRow.userId, true)
      //     this.usersInstance.option('focusedRowIndex', -1)
      //     this.usersInstance.option('focusedRowKey', this.usersInstance.option('dataSource').length)
      //   }
      // }
    },

    addAuths() {
      const newRow = {
        id: (this.authsList.length + 1) + '',
        sysCd: this.$store.state.system.sysCd,
        authCd: '',
        authNm: '',
        srt: '0',
        __modified__: false,
        __created__: true
      }

      this.authsInstance.newRow(newRow)
      this.authsInstance.selectRows(newRow.id, true)
      this.authsInstance.option('focusedRowIndex', -1)
      this.authsInstance.option('focusedRowKey', this.authsInstance.option('dataSource').length + '')

      // console.log('this.authsList', this.authsList)
    },

    async saveAuths() {
      await this.authsInstance.saveEditData()

      const selectedRows = await this.authsInstance.getSelectedRowsData()

      // console.log('selectedMainRows', selectedMainRows)

      if (selectedRows.length < 1) {
        this.vToastify(this.$t('SelectCheck'), 'warn')
        return
      }

      for (let row of selectedRows) {
        if (!row.authCd) {
          this.vToastify(this.$t('requiredCheck') + '[Group Code]', 'warn')
          return
        }

        if (row.__created__ !== true) {
          row.__modified__ = true
        }

        row.editor = this.$store.state.user.userId
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        msgRes => {
          this.openLoading()
          this.authsInstance.beginUpdate()

          // console.log('selectedRows', selectedRows)

          saveAuths(selectedRows, true)
            .then(res => {
              // console.log('res', res)

              this.searchAuths()
              const message = selectedRows[0].__created__ === true ? 'Saved' : 'changed'

              // console.log('message', message)

              notify(this.$t(message), 'success', 3000)
            })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {
              this.authsInstance.endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async deleteAuths() {
      await this.authsInstance.saveEditData()

      const selectedRows = await this.authsInstance.getSelectedRowsData()

      // console.log('selectedMainRows', selectedMainRows)

      if (!selectedRows.length) {
        this.vToastify(this.$t('SelectCheck'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.openLoading()
          this.authsInstance.beginUpdate()

          // console.log('selectedRows', selectedRows)

          deleteAuths(selectedRows, true)
            .then(res => {
              // console.log('res', res)

              this.searchAuths()
              notify(this.$t('deleted'), 'success', 3000)
            })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {
              this.authsInstance.endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    addMenus() {
      if(this.selectedUser) {       

        let param = { makerCd: this.selectedUser.userId }
        this.menuPopData.push(param)
        this.showMenuPop = true
        
      } else {
        this.vToastify(this.$t('SelectCheck'), 'warn')
      }
    },

    async saveMenus() {
      await this.menusInstance.saveEditData()

      const selectedRows = await this.menusInstance.getSelectedRowsData('all')

      //  console.log('selectedRows', selectedRows)
      //  console.log('selectedRows.length', selectedRows.length)

      if (selectedRows.length < 1) {
        this.vToastify(this.$t('SelectCheck'), 'warn')
        return
      }

      for (let row of selectedRows) {
        if (row.__created__ !== true) {
          row.__modified__ = true
        }

        row.editor = this.$store.state.user.userId
        row.userId = this.selectedUser.userId
        
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'warn',
        current => {
          // console.log('current', current)

          this.openLoading()
          this.menusInstance.beginUpdate()

          saveMenus(selectedRows, true)
            .then(res => {
              // console.log('res', res)

              this.searchMenus()
              const message = selectedRows[0].__created__ === true ? 'Saved' : 'changed'

              // console.log('message', message)

              notify(this.$t(message), 'success', 3000)
            })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {
              this.menusInstance.endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },

    async deleteMenus() {
      await this.menusInstance.saveEditData()

      const selectedRows = await this.menusInstance.getSelectedRowsData('all')

      for (let row of selectedRows) {             
        row.userId = this.selectedUser.userId,  
        row.sysCd  = this.$store.state.system.sysCd      
      }

      
      // console.log('selectedRows', selectedRows)


      if (!selectedRows.length) {
        this.vToastify(this.$t('SelectCheck'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.openLoading()
          this.menusInstance.beginUpdate()

          // console.log('selectedRows', selectedRows)

          deleteMenus(selectedRows, true)
            .then(res => {
              // console.log('res', res)

              this.searchMenus()
              notify(this.$t('deleted'), 'success', 3000)
            })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {
              this.menusInstance.endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },

    addUsers() {
      
      // console.log(this.authDiv.select.cd)

      //  if(this.selectedAuth) {
      if(this.authDiv.select.cd !== null)  {
        
        let param = { authCd: this.authDiv.select.cd }

        this.userPopData.push(param)

        this.showUserPop = true
      } else {
        this.vToastify(this.$t('SelectCheck'), 'warn')      
      }
    },    


    async saveUsers() {
      await this.usersInstance.saveEditData()

      const selectedRows = await this.usersInstance.getSelectedRowsData()

      // console.log('selectedMainRows', selectedMainRows)

      if (selectedRows.length < 1) {
        this.vToastify(this.$t('SelectCheck'), 'warn')
        return
      }

      for (let row of selectedRows) {
        if (!row.authCd) {
          this.vToastify(this.$t('requiredCheck') + '[Group Code]', 'warn')
          return
        }

        if (row.__created__ !== true) {
          row.__modified__ = true
        }

        row.editor = this.$store.state.user.userId
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        msgRes => {
          this.openLoading()
          this.usersInstance.beginUpdate()

          // console.log('selectedRows', selectedRows)

          saveUsers(selectedRows, true)
            .then(res => {
              // console.log('res', res)

              this.searchUsers()
              const message = selectedRows[0].__created__ === true ? 'Saved' : 'changed'

              // console.log('message', message)

              notify(this.$t(message), 'success', 3000)
            })
            .catch(error => {
              this.vToastify(error, 'warn')
            })
            .finally(() => {
              this.usersInstance.endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    // async deleteUsers() {
    //   await this.usersInstance.saveEditData()

    //   const selectedRows = await this.usersInstance.getSelectedRowsData()

    //   // console.log('selectedMainRows', selectedMainRows)

    //   if (!selectedRows.length) {
    //     this.vToastify(this.$t('SelectCheck'), 'warn')
    //     return
    //   }

    //   this.vToastifyPrompt(
    //     this.$t('doDeleteData'),
    //     'info',
    //     current => {
    //       this.openLoading()
    //       this.usersInstance.beginUpdate()

    //       // console.log('selectedRows', selectedRows)

    //       deleteUsers(selectedRows, true)
    //         .then(res => {
    //           // console.log('res', res)

    //           this.searchUsers()
    //           notify(this.$t('deleted'), 'success', 3000)
    //         })
    //         .catch(error => {
    //           this.vToastify(error, 'warn')
    //         })
    //         .finally(() => {
    //           this.usersInstance.endUpdate()
    //           this.endLoading()
    //         })
    //     },
    //     null,
    //     true
    //   )
    // }
  },
  mounted() {
    this.searchAuths()    
  }
}
</script>

<style lang="scss" scoped>
.subTitle {
  font-weight: bold;
  color: black;
}
</style>